// extracted by mini-css-extract-plugin
export default {"numberElementWithIcon":"fI21ym","icon":"cQR_2d","metadata":"MMprj4","tooltip":"Jd7J5m","link":"sGqge5","button":"q1TK7O"};